import { render, staticRenderFns } from "./DepartmentHistoryNew.vue?vue&type=template&id=96cd457a&scoped=true&lang=pug&"
import script from "./scripts/DepartmentHistoryNew.js?vue&type=script&lang=js&"
export * from "./scripts/DepartmentHistoryNew.js?vue&type=script&lang=js&"
import style0 from "./DepartmentHistoryNew.vue?vue&type=style&index=0&id=96cd457a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cd457a",
  null
  
)

export default component.exports